import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/write-for-us/modules/client-page.tsx");
